<template>
  <div
    id="combat"
    class="relative flex flex-col justify-start items-center bg-combat-section bg-no-repeat bg-cover py-16 px-4 overflow-hidden"
  >
    <section-title titlePath="title-10.png" />
    <div class="btns flex flex-row justify-center w-full mb-5">
      <div
        v-for="(menu, index) in menuData"
        :key="index"
        :class="{ menuActive: menu.isActive }"
        class="cursor-pointer w-244 h-54 m-3 text-white font-elmessiri text-md flex justify-center items-center bg-cover bg-center bg-btn-off"
        @click="handleMenu(index)"
      >
        {{ menu.text }}
      </div>
    </div>
    <transition-group
      name="fade"
      tag="div"
      class="relative w-full h-508 flex justify-center items-start"
    >
      <div
        v-show="menuData[0].isActive"
        class="absolute w-full max-w-790 flex flex-col justify-center items-center z-20 lg:max-w-538"
        :key="menuData[0].text"
      >
        <img :src="`${imgPath}/slide11/img_weeklychallenge.png`" />
        <p class="w-full max-w-632 text-center font-nunito text-grayish-orange">
          Weekly challenges have 3 difficult missions for you to complete. Each
          completion will reward you with items and Challenge Points. These
          challenge points can help you get the best in-slot glasses: Weekly
          Challenge Glasses. Box of Challenges can also be opened for random
          rewards, with a top prize: Great Mei, the rarest pet in the game.
        </p>
      </div>
      <div
        v-show="menuData[1].isActive"
        class="absolute w-full max-w-790 h-504 flex flex-col justify-center items-center"
        :key="menuData[1].text"
      >
        <div class="w-full">
          <img :src="`${imgPath}/slide11/img_pvp.png`" />
        </div>
        <div class="w-full bg-black bg-opacity-70 py-4 px-3 mt-2">
          <div
            v-for="(pvp, index) in pvpData"
            :key="index"
            class="flex flex-row mt-2"
          >
            <span
              :style="{ background: pvp.color }"
              class="text-white font-bold w-7 h-7 flex justify-center items-center mr-2"
              v-html="pvp.number"
            ></span>
            <p
              class="w-full max-w-300 text-grayish-orange text-sm"
              v-html="pvp.desc"
            ></p>
          </div>
        </div>
      </div>
    </transition-group>
    <img
      class="absolute -bottom-9 left-3 h-auto jewelstar invisible"
      :src="`${imgPath}/slide11/jewelstar.png`"
    />
  </div>
</template>

<script>
import breakpoints from '@/plugins/breakpoints';
import SectionTitle from '../components/SectionTitle/SectionTitle';
export default {
  components: {
    SectionTitle,
  },
  data: function() {
    return {
      breakpoints,
      imgPath: process.env.VUE_APP_IMG_URL,
      menuData: [
        {
          text: 'Weekly Challenge',
          isActive: true,
        },
        {
          text: 'PvP',
          isActive: false,
        },
      ],
      pvpData: [
        {
          color: '#B033E3',
          number: 'A',
          desc: 'Users can choose berween Normal or Ranked',
        },
        {
          color: '#F6AC09',
          number: 'B',
          desc: 'Users can check their win rates, PvP points, and rank',
        },
        {
          color: '#69D404',
          number: 'C',
          desc: 'Users can choose between 1v1 or 2v2',
        },
        {
          color: '#de2120',
          number: 'D',
          desc: 'Users can check their class, win rate, and other information',
        },
        {
          color: '#0190fd',
          number: 'E',
          desc: 'Users can check their PvP stats (Win/Tie/Loss) and win rate',
        },
        {
          color: '#f85a01',
          number: 'F',
          desc: 'Users can check more information about the selected PvP mode',
        },
      ],
    };
  },
  methods: {
    handleMenu: function(menuIndex) {
      for (let i = 0; i < this.menuData.length; i++) {
        if (menuIndex === i) {
          this.menuData[i].isActive = true;
        } else {
          this.menuData[i].isActive = false;
        }
      }
    },
  },
};
</script>
<style lang="postcss" scoped>
.btns .menuActive {
  @apply bg-btn-on;
}
</style>
